import { useContext, useEffect, useRef } from 'react'
import { InternalContext } from '../../contexts/InternalContext'
import { useGetVisibleRatioPosition } from '../../hooks/useGetVisibleRatioPosition'
import { useChannelsElementRect } from './useChannelsElementRect'
import { useElementEventListener } from '../../../hooks/useElementEventListener'

export function useChannelsMousePositioning() {
  const { backgroundElement, mousePosition } = useContext(InternalContext)
  const getVisibleRatioPosition = useGetVisibleRatioPosition()
  const { width, left } = useChannelsElementRect()
  const lastClientXRef = useRef<number | null>(null)
  const update = ({ clientX }: MouseEvent) => {
    mousePosition.value = getVisibleRatioPosition((clientX - left) / width)
    lastClientXRef.current = clientX
  }

  useEffect(() => {
    if (lastClientXRef.current) {
      mousePosition.value = getVisibleRatioPosition((lastClientXRef.current - left) / width)
    }
  }, [getVisibleRatioPosition, mousePosition, width, left])

  useElementEventListener(backgroundElement, 'mouseenter', update)
  useElementEventListener(backgroundElement, 'mousemove', update)
  useElementEventListener(backgroundElement, 'mouseleave', () => {
    mousePosition.value = null
    lastClientXRef.current = null
  })
}
